
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<CalendarNavigator>({})
export default class CalendarNavigator extends Vue {
	@Prop({ type: String, required: false, default: '' }) private label!: string;
	@Prop({ type: String, required: false, default: undefined }) private prevAriaLabel!: string;
	@Prop({ type: String, required: false, default: undefined }) private nextAriaLabel!: string;
	@Prop({ type: Boolean, required: false, default: false }) private prevDisabled!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private nextDisabled!: boolean;
}
